import PresortDemo from "../components/table/DataTable";
import { useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css"
import { } from "../store/api/orderAPI";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { confirmPopup } from 'primereact/confirmpopup';
import { storeColumns } from "../metadata/direcroty";
import { useCreateEditStoreMutation, useDeleteStoreMutation, useGetStoreQuery } from "../store/api/directory/storeApi";
import { t } from "i18next";




function Shops() {
    const { data, error, isLoading } = useGetStoreQuery();
    const [createOrUpdateTarif] = useCreateEditStoreMutation();
    const [deleteTarif] = useDeleteStoreMutation()
    const delTarif = (event, [row]) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Вы точно хотите удалить?',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'reject',
            accept: (e) => {
                deleteTarif(row.guid);

            }
        });
    };
    const actions = useActionsHook([
        {
            onClick: (e, ...params) => {
                delTarif(e, params)

            },
            icon: "pi pi-trash"
        }
    ])
    const items = [
        {
            label: 'Add',
            icon: 'pi pi-pencil',
            command: () => {
                // toast.current.show({ severity: 'info', summary: 'Add', detail: 'Data Added' });
            }
        },
        {
            label: 'Update',
            icon: 'pi pi-refresh',
            command: () => {
                // toast.current.show({ severity: 'success', summary: 'Update', detail: 'Data Updated' });
            }
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
                // toast.current.show({ severity: 'error', summary: 'Delete', detail: 'Data Deleted' });
            }
        },
        {
            label: 'Upload',
            icon: 'pi pi-upload',
            command: () => {
                // router.push('/fileupload');
            }
        },
        {
            label: 'React Website',
            icon: 'pi pi-external-link',
            command: () => {
                // window.location.href = 'https://react.dev/';
            }
        }
    ];

    const [formData, setFormData] = useState({

    });

    const [visibleLeft, setVisibleLeft] = useState({
        visible: false,
        data: null
    });

    function toggleSidebar(bool, data) {
        setFormData(data)
        setVisibleLeft(state => {
            return {
                visible: bool,
                data: data
            }
        })
    }

    const onBlur = (e, attr, value) => {
        setFormData(state => {
            return {
                ...state,
                [attr]: value
            }
        });
    }


    return (<>
        <p
            style={{
                paddingLeft: 12,
                fontSize: 18,
                fontWeight: 600,
            }}
        >
            {t("shop")}
        </p>
        <PresortDemo
            isLoading={isLoading}
            data={data}
            column={storeColumns.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
            toggleSidebar={toggleSidebar}
            deleteHandler={(row, field) => {
                console.log(row, field);
            }}
            actions={actions} />
        <SpeedDial
            model={items}
            radius={120}
            type="quarter-circle"
            onClick={() => {
                toggleSidebar(true, {});
            }}
            direction="up-left"
            style={{ right: 15, bottom: 15 }} />
        <Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
            <div className="user-sidebar-edit">
                {
                    storeColumns.filter((i) => i.editor).map(el => {
                        return (
                            <div>
                                <Editor {...el} onBlur={onBlur} data={formData} />
                            </div>
                        )
                    })
                }
                <div></div>
                <MyButton label={t("save")} onClick={() => {
                    createOrUpdateTarif(formData);
                    toggleSidebar(false, {});
                }} />

            </div>

        </Sidebar>
    </>);
}

export default Shops;